<template>
  <div style="width: 100%; height: 20px; margin-top: 5px;">
    <div class="main-bar">
      <div class="completed-bar" :style="{width: completedWidth}">
        <div class="completed-bar-fill"></div>
        <div class="shimmer" :style="{animationDelay: Math.random() * 0.8 + 's'}"></div>
      </div>
      <div v-for="(achievement, index) in achievementPoints" :key="index" class="achievement-point"
      :style="{left: `calc(${achievement.requirement * 100}%)`}">
        <div v-if="achievement.reward" class="achievement-text" :style="{
          color: achievement.requirement <= progress ? 'yellow' : 'dimgray',
          transform: `translate( ${achievement.requirement * 100 * -1 + '%'}, 12px)`
        }">{{ achievement.reward }}</div>
        <div class="achievement-dot" :style="{
          borderColor: achievement.requirement <= progress ? '#8deb16' : 'gray',
          backgroundColor: achievement.requirement <= progress ? '#457c00' : 'black'
        }">
          <div class="dot-shimmer" :style="{
          borderColor: achievement.requirement <= progress ? '#8deb16' : 'gray',
          animationDelay: Math.random() * 3.5 + 's'
        }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'achievement-progress-bar',
  props: {
    achievements: Array,
    progress: Number
  },
  computed: {
    achievementPoints () {
      let achievementPoints = []
      for (const achievement of this.achievements) {
        achievementPoints.push({
          achieved: achievement.requirement <= this.progress,
          requirement: achievement.requirement,
          reward: achievement.reward
        })
      }
      return (achievementPoints)
    },
    completedWidth () {
      return this.progress < 1 ? 100 * this.progress + '%' : '100%'
    }
  }
}
</script>

<style>
.main-bar{
  position: relative;
  background: rgba(255, 255, 255, 0.2);
  width: 100%;
  height: 5px;
}
.completed-bar{
  position: absolute;
  height: 5px;
  overflow: hidden;
}
.completed-bar-fill{
  height: 100%;
  background: #8deb16;
  overflow: hidden;
  animation: expand 0.6s ease-out;
  border-radius: 0 10px 10px 0;
}
.shimmer{
  position: absolute;
  background: #EDDD53;
  background: linear-gradient(90deg,rgba(237, 221, 83, 0) 0%, rgba(255, 249, 201, 1) 50%, rgba(237, 221, 83, 0) 100%);
  width: 40px;
  height: 100px;
  transform: rotate(65deg) translate(-50%, -68%);
  animation: moveRight 1s linear infinite;
}
.achievement-point{
  position: absolute;
}
.achievement-dot{
  position: relative;
  border: 3px gray solid;
  top: -5px;
  left: -10px;
  width: 10px;
  height: 10px;
  border-radius: 100%;
}
.dot-shimmer{
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: 1px #8deb16 solid;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  opacity: 1;
  animation: growAndFade 2s ease-in-out infinite;
}
.achievement-text{
  position: absolute;
  padding: 2px 4px;
  background: rgba(0,0,0,0.2);
  border: 1px solid gray;
  border-radius: 5px;
  width: max-content;
  font-size: 12px;
  top: 2px;
  background: black;
}
@keyframes moveRight {
  0% {
    left: -30%;
  }
  100% {
    left: 100%; /* Moves across the full width of the parent */
  }
}
@keyframes growAndFade {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
  20% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(4);
    opacity: 0;
  }
}
@keyframes expand {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AchievementProgressBar.vue